import { apiRequest } from "./client";

/** Tell support a topic has no questions, with the student's own words. */
export function reportMissingTopic(input: {
  topicId: string;
  topicName: string;
  subjectId: string;
  subjectName: string;
  message: string;
}): Promise<{ sent: boolean }> {
  return apiRequest<{ sent: boolean }>("/api/feedback/missing-topic", {
    method: "POST",
    body: input,
    authenticated: true,
  });
}
